import { AnalyzeUrlResponseType } from '@src/types/main';

import { apiSlice } from '../api/api-slice';

export const scrappingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    scrapeUrl: builder.mutation<AnalyzeUrlResponseType, string>({
      query: (url) => ({
        url: `/scrape?url=${encodeURIComponent(url)}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useScrapeUrlMutation } = scrappingApiSlice;
